import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess206701ParamStatus: 'idle',
    startProcess206701ParamError: undefined as any,
    loadUserParamsProcess206701ParamStatus: 'idle',
    loadUserParamsProcess206701ParamError: undefined as any,

    process206701ParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess206701Param = createAsyncThunk('process206701ParamSlice/startProcess206701Param', async ({ process206701Param }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess206701Param/`,
        prepareData(process206701Param),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess206701ParamStatus } = getState().process206701ParamSlice
        return startProcess206701ParamStatus !== 'pending'
    }
})

export const loadUserParamsProcess206701Param = createAsyncThunk('process206701ParamSlice/loadUserParamsProcess206701Param', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess206701Param/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess206701ParamStatus } = getState().process206701ParamSlice
        return loadUserParamsProcess206701ParamStatus !== 'pending'
    }
})

const Process206701ParamSlice = createSlice({
    name: 'process206701ParamSlice',
    initialState,
    reducers: {
        resetstartProcess206701Param: (state) => {
            state.job = undefined
            state.startProcess206701ParamError = undefined
        },
        resetstartProcess206701ParamError: (state) => {
            state.startProcess206701ParamError = undefined
        },
        resetloadUserParamsProcess206701Param: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess206701ParamError = undefined
        },
        resetloadUserParamsProcess206701ParamError: (state) => {
            state.loadUserParamsProcess206701ParamError = undefined
        },
        removeFromProcess206701ParamListById: (state, action) => {
            state.process206701ParamList = state.process206701ParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess206701ParamListByIds: (state, action) => {
            state.process206701ParamList = state.process206701ParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process206701ParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess206701ParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process206701ParamList = []
            state.startProcess206701ParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess206701Param.pending, (state) => {
            state.startProcess206701ParamStatus = 'pending'
            state.startProcess206701ParamError = undefined
        })
        builder.addCase(startProcess206701Param.fulfilled, (state, action) => {
            state.startProcess206701ParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess206701Param.rejected, (state, action) => {
            state.startProcess206701ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess206701ParamError = action.error.message
            } else {
                state.startProcess206701ParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess206701Param.pending, (state) => {
            state.loadUserParamsProcess206701ParamStatus = 'pending'
            state.loadUserParamsProcess206701ParamError = undefined
        })
        builder.addCase(loadUserParamsProcess206701Param.fulfilled, (state, action) => {
            state.loadUserParamsProcess206701ParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess206701Param.rejected, (state, action) => {
            state.loadUserParamsProcess206701ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess206701ParamError = action.error.message
            } else {
                state.loadUserParamsProcess206701ParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess206701Param,
    resetstartProcess206701ParamError,
    resetloadUserParamsProcess206701Param,
    resetloadUserParamsProcess206701ParamError,
    removeFromProcess206701ParamListById,
    removeFromProcess206701ParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process206701ParamSlice.actions
export default Process206701ParamSlice.reducer
